// This file is automatically generated. DO NOT EDIT.

import { type PrioritizationResult } from '../../../../types/response/PrioritizationResult';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetPrioritizationResultsResponse {
  /** The prioritization results */
  results: Array<PrioritizationResult>;
}

export async function getPrioritizationResultsResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetPrioritizationResultsResponse>,
): Promise<GetPrioritizationResultsResponse> {
  return getJSONResponse<GetPrioritizationResultsResponse>(
    response,
    'getPrioritizationResultsResponse',
    options,
  );
}
